import React from 'react';
import PropTypes from 'prop-types';

import Definition from '../../../shared/Definition';

const Breeder = ({ breederName, className }) => (
    breederName ? (
        <Definition
            term="Breeder"
            className={className}
            description={breederName}
        />
    ) : null
);

Breeder.propTypes = {
    breederName: PropTypes.string,
    className: PropTypes.string,
};

export default Breeder;



// WEBPACK FOOTER //
// ./src/js/horse/details/components/Breeder.jsx